export default "__VITE_ASSET__Clh6yJCH__"